import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const postSupport = (data: any) => {
  data.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
  return axios({
    method: "POST",
    url: `/support`,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSupportList = () => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/support",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
